<template>
    <div>
        <Breadcrumbs main="User" title="Add Slider Group" />
			<div class="container-fluid">
				<div class="row">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-body">
								<form @submit.prevent="addGroup" enctype="multipart/form-data">
									<div class="form theme-form">
										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Title <span class="text-danger">*</span></label>
													<!-- <input class="form-control" type="text" placeholder=""> -->
													<input class="form-control" type="text" v-model="group.title" v-bind:class="{ 'is-invalid': Boolean(errors.title) }" minlength="3" maxlength="100" @keypress="alphaSpacesOnly"/>
													<div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Location <span class="text-danger">*</span></label>
													
													<GMapAutocomplete 
														@place_changed="setPlace" class="form-control" 
														placeholder="Search here to pick the required latitude and longitude..."
														:value="group.location">
													</GMapAutocomplete>

													<GMapMap  v-if="group.location"
														:center="center"
														:zoom="18"
														map-style-id="roadmap"
														:options="mapOptions"
														style="width: 100%; height: 30vmin"
														ref="mapRef"
														@click="handleMapClick">
															<GMapMarker 
															:position="marker.position"
															:clickable="true"
															:draggable="true"
															@drag="handleMarkerDrag"
															@click="panToMarker"
															/>
													</GMapMap > 
													
													<div v-for="(val, index) in errors.location" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Latitude<span class="text-danger">*</span></label>
													<!-- <input class="form-control" type="text" placeholder=""> -->
													<input v-model="marker.position.lat" class="form-control" type="text" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }" minlength="3" maxlength="100" @keypress="decimalsOnly"/>
													<div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Longitude <span class="text-danger">*</span></label>
													<!-- <input class="form-control" type="password" placeholder=""> -->
													<input v-model="marker.position.lng" type="text" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }" minlength="3" maxlength="100" @keypress="decimalsOnly"/>
													<div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
										</div>
										<div class="col-sm-6">
											<button class="btn btn-primary me-3" type="submit">Add</button>
											<button class="btn btn-light" >Reset</button>
											<!-- <button type="submit" class="mr-3" variant="primary">Add</button>
											<button class="" variant="light">Reset</button> -->
										</div>
										<projectForm />
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>

	</div>
</template>

<script>

	export default {
		name: "AddGroup",
		

		data() {
			
			return {
				group: {
					id: null,
					title: "",
					location: "",
					latitude: null,
					longitude: null,
				},

				marker: { 
					position: { 
						lat: 11.2587531, 
						lng: 75.78041  
					} 
				},
				center: { 
					lat: 11.2587531, 
					lng: 75.78041  
				},
				current_place: null,
				mapOptions: {
					disableDefaultUI: true,
				},

					token: "",
					errors: {},
			};
		},
		mounted() {
			
		},

		created() {
			
		},

		methods: {
			decimalsOnly(event) {
		      let keyCode = event.keyCode;
		      if (keyCode < 48 || keyCode > 57) {
		        event.preventDefault();
		      }
		    },
			alphaSpacesOnly(event) {
				let keyCode = event.keyCode;
				if ((keyCode >= 65 && keyCode <= 90) || 
					(keyCode >= 97 && keyCode <= 122) ||			    	
					(keyCode == 32)) {
					return;
				} else {
					event.preventDefault();
				}
			},

		   	// geolocate() {

			// 	navigator.geolocation.getCurrentPosition((position) => {
			// 		this.marker.position = {
			// 			lat: position.coords.latitude,
			// 			lng: position.coords.longitude,
			// 		};
						
			// 		this.group.location = position.formatted_address;
			// 		alert(this.marker.position.formatted_address);
			// 		this.panToMarker();
			// 	});
    		// },
    		
    		handleMarkerDrag(e) {
      			this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    		},

    		panToMarker() {
				// address.panTo(this.marker.position);
				this.$refs.mapRef.panTo(this.marker.position);
            	// this.$refs.mapRef.setZoom(18);
    		},

    		handleMapClick(e) {
				this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
				console.log(e);
    		},

    		setPlace(place) {
    			this.current_place = place;
    			if(this.current_place) {
    				const marker = {
	    				lat: this.current_place.geometry.location.lat(),
	    				lng: this.current_place.geometry.location.lng(),
	    			};
	    			this.center = marker;
	    			this.marker.position = marker;
	    			this.group.location = place.formatted_address;
	    			this.group.latitude = marker.lat;
	    			this.group.longitude = marker.lng;
    			}
    		},

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			addGroup() {

				this.getToken();
				let formData = new FormData();
				formData.append("title", this.group.title);
				formData.append("location", this.group.location);
				formData.append("latitude", this.marker.position.lat);
				formData.append("longitude", this.marker.position.lng);
				
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				url = "/api/admin/groups/add";

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								console.log(error.response.data);
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			clearForm() {
				this.group.title = "";
				this.group.location = "";				
				this.marker.position.lat = "";
				this.marker.position.lng = "";
				this.errors = {};
			},
		},
	};
</script>
